import { useCurrentUser } from "@/hooks/use-current-user";
import { api } from "@/lib/api-client";
import { useMarketplaceWorkspace } from "./use-marketplace-workspace";
import {
  hasProfessionalDesk,
  professionalDeskHrefs,
} from "@/lib/professional-desk";

export function useProfessionalDesk() {
  const { user } = useCurrentUser();
  const accessStatus = api.os.professionalAccess.getAccessStatus.useQuery(
    undefined,
    { enabled: !!user && !user.isAgent },
  );
  const isProfessional = hasProfessionalDesk({
    isAgent: user?.isAgent,
    grants: accessStatus.data?.grants,
  });
  const { data: workspaces } = api.os.workspace.listWorkspaces.useQuery(
    undefined,
    { enabled: isProfessional || Boolean(user?.isStaff) },
  );
  const handle = workspaces?.userHandle?.trim() || user?.handle?.trim() || null;
  const hrefs = professionalDeskHrefs({ isProfessional, handle });
  const marketplace = useMarketplaceWorkspace(isProfessional);
  // Keep a pending/unavailable selection explicit; never redirect its work to
  // the helper's own desk just because the context query has not succeeded.
  const basePath =
    marketplace.data?.basePath ??
    marketplace.rememberedPath?.replace(/\/dashboard$/, "");

  return {
    isProfessional,
    handle: isProfessional ? handle : null,
    ...hrefs,
    ...(basePath
      ? {
          osHref: `${basePath}/dashboard`,
          listingsHref: `${basePath}/inventory`,
          chatHref: `${basePath}/conversations`,
        }
      : {}),
    marketplace,
    profileHref: isProfessional && handle ? `/os/~${handle}/profile` : null,
    accountHref:
      isProfessional && handle
        ? `/os/~${handle}/settings/account`
        : "/settings/account",
  };
}
